import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { Community, CommunityRole } from "@upsquad/shared";
import type { PersistConfig } from "redux-persist";
import { logOut } from "@/src/auth/store/auth-slice";
import { webStorage } from "@/src/common/services/storage.service";

interface CommunityState {
	communities: Community[];
	activeCommunityId: string | null;
	activeMemberRole: CommunityRole | null;
}

const initialState: CommunityState = {
	communities: [],
	activeCommunityId: null,
	activeMemberRole: null,
};

export const communitySlice = createSlice({
	name: "community",
	initialState,
	reducers: {
		setCommunities: (state, { payload }: PayloadAction<Community[]>) => {
			state.communities = payload;
		},
		setActiveCommunityId: (state, { payload }: PayloadAction<string | null>) => {
			state.activeCommunityId = payload;
		},
		setActiveMemberRole: (state, { payload }: PayloadAction<CommunityRole | null>) => {
			state.activeMemberRole = payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(logOut, () => initialState);
	},
});

export const { setCommunities, setActiveCommunityId, setActiveMemberRole } = communitySlice.actions;

export const communityPersistConfig: PersistConfig<CommunityState> = {
	key: "community",
	storage: webStorage,
	whitelist: ["communities", "activeCommunityId"],
};
